import {
  BoosterDataAction,
  LOAD_BOOSTER_AUTO_OPTIMIZE,
  LOAD_BOOSTER_AUTO_OPTIMIZE_FAIL,
  LOAD_BOOSTER_AUTO_OPTIMIZE_SUCCESS,
  LOAD_BOOSTER_DATA,
  LOAD_BOOSTER_DATA_FAIL,
  LOAD_BOOSTER_DATA_SUCCESS,
  LOAD_BOOSTER_OPTIMIZE_STATUS,
  LOAD_BOOSTER_OPTIMIZE_STATUS_FAIL,
  LOAD_BOOSTER_OPTIMIZE_STATUS_SUCCESS,
  LoadBoosterAutoOptimize,
  LoadBoosterAutoOptimizeFail,
  LoadBoosterAutoOptimizeSuccess,
  LoadBoosterData,
  LoadBoosterDataFail,
  LoadBoosterDataSuccess,
  LoadBoosterOptimizeStatus,
  LoadBoosterOptimizeStatusFail,
  LoadBoosterOptimizeStatusSuccess
} from "../actions";
import {BoosterMode} from "../../websites/website/booster/services/booster.service";
import {BoosterPage} from "../../websites/website/booster/mappers/booster-page";

export interface IBoosterEntityDataState {
  modeLevel: BoosterMode;
  testMode: 'on'|'off'|null;
  pages: BoosterPage[];
  customPages: BoosterPage[];
  pageCacheStatus: {};
  incompatibleActivePlugins: [];
  pagesCount: number;
  pluginInfo: any;
  webpStatus: {};
  optimizeStatus: {};
  autoOptimizeEnabled: boolean;
  loading: boolean;
  loaded: boolean;
}

export interface IBoosterData {
  entities: {[websiteId: number]: IBoosterEntityDataState};
  loading: boolean;
  loaded: boolean;
}

export const initialState: IBoosterData = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IBoosterData = initialState, action: BoosterDataAction): IBoosterData {
  let payload: any;

  switch (action.type) {

    case LOAD_BOOSTER_DATA:
      payload = (<LoadBoosterData>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_BOOSTER_DATA_SUCCESS:
      payload = (<LoadBoosterDataSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            pages: payload.pages,
            pagesCount: payload.pagesCount,
            customPages: payload.customPages,
            modeLevel: payload.modeLevel,
            incompatibleActivePlugins: payload.incompatibleActivePlugins,
            pluginInfo: payload.pluginInfo,
            testMode: payload.testMode,
            pageCacheStatus: payload.pageCacheStatus,
            webpStatus: payload.webpStatus,
            loading: false,
            loaded: true
          }
        }
      };

    case LOAD_BOOSTER_DATA_FAIL:
      payload = (<LoadBoosterDataFail>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };

    case LOAD_BOOSTER_OPTIMIZE_STATUS:
      payload = (<LoadBoosterOptimizeStatus>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_BOOSTER_OPTIMIZE_STATUS_SUCCESS:
      payload = (<LoadBoosterOptimizeStatusSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            optimizeStatus: payload.optimizeStatus,
            loading: false,
            loaded: true
          }
        }
      };

    case LOAD_BOOSTER_OPTIMIZE_STATUS_FAIL:
      payload = (<LoadBoosterOptimizeStatusFail>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };

    case LOAD_BOOSTER_AUTO_OPTIMIZE:
      payload = (<LoadBoosterAutoOptimize>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_BOOSTER_AUTO_OPTIMIZE_SUCCESS:
      payload = (<LoadBoosterAutoOptimizeSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            autoOptimizeEnabled: payload.autoOptimizeEnabled,
            loading: false,
            loaded: true
          }
        }
      };

    case LOAD_BOOSTER_AUTO_OPTIMIZE_FAIL:
      payload = (<LoadBoosterAutoOptimizeFail>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };

  }

  return state;
}
